<template>
    <!-- <a :href="showImage(filename)"><v-img 
        :key="filename"
        aspect-ratio="1"
        :lazy-src="showImage(filename)"
        :src="showImage(filename)"
    ></v-img></a> -->

    <!-- 
        :lazy-src="'data:image/jpeg;base64,'+this.image64"
        :src="'data:image/jpeg;base64,'+this.image64"
    -->
    <v-img style="cursor:pointer;"
        aspect-ratio="1"
        :lazy-src="this.image64"
        :src="this.image64"
    ></v-img>
</template>

<script>
export default {
    props: {
        image64: {
            type    : String,
            required: true
        },
    },
    methods: {

        // showImage: function(imageOrderName) {
        //     let imageOrder = 'https://hst-api.wialon.com/wialon/ajax.html?sid='+this.session+'&svc=order/get_attachment&params={"itemId":'+this.user+',"id":'+this.pedido+',"path": "'+imageOrderName+'"}'
        //     return imageOrder
        // }
    }
}
</script>

<style>

</style>